<template>
  <div class="my-2">
    <div v-if="formSubmited">
      <h4>Rock on!</h4>
      <p>
        Your registration was successful. Now let's get your training ready to
        rock n' roll.
      </p>
      <br />
      <p>Click the link below to go to your organization's page.</p>
      <br />
      <a :href="`//${url}`">https://{{ url }}</a>
    </div>
    <form @submit.prevent="submitBillingForm" name="billing-info" v-else>
      <h4>Subscription Options</h4>
      <div class="form-group required" v-for="price in prices" :key="price">
        <div class="form-check">
          <input
            class="form-check-input"
            type="radio"
            name="subcription"
            :id="price.id"
            :value="price.id"
            :checked="selectedPriceId === price.id"
            @click="selectedPriceId = price.id"
          />
          <label class="form-check-label" :for="price.id">
            {{ price.label }}
          </label>
        </div>
      </div>
      <br />
      <h4>Billing Information</h4>
      <div class="form-group required">
        <label for="orgName" class="control-label">Name</label>
        <div>
          <input
            type="text"
            maxlength="50"
            name="name"
            class="form-control"
            v-model="formData.name.value"
            :class="{ 'is-invalid': formData.name.errors.length > 0 }"
            @focus="removeError('name')"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.name.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>

      <div class="form-group required">
        <label class="control-label">Email</label>
        <div>
          <input
            type="email"
            class="form-control"
            name="email"
            v-model="formData.email.value"
            :class="{ 'is-invalid': formData.email.errors.length > 0 }"
            @focus="removeError('email')"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.email.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">Address</label>
        <div>
          <input
            type="text"
            class="form-control"
            name="line1"
            v-model="formData.line1.value"
            :class="{ 'is-invalid': formData.line1.errors.length > 0 }"
            @focus="removeError('line1')"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.line1.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">City</label>
        <div>
          <input
            type="text"
            maxlength="50"
            class="form-control"
            name="city"
            v-model="formData.city.value"
            :class="{ 'is-invalid': formData.city.errors.length > 0 }"
            @focus="removeError('city')"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.city.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">State</label>
        <div>
          <region-select
            v-model="formData.state.value"
            :country="formData.country.value"
            :region="formData.state.value"
            :usei18n="usei18n"
            className="form-control"
          />

          <div class="error-wrapper">
            <p
              v-for="error in formData.state.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>

      <div class="form-group required">
        <label class="control-label">Zip</label>
        <div>
          <input
            type="text"
            pattern="[0-9]{5}"
            class="form-control"
            name="zip"
            :class="{ 'is-invalid': formData.zip.errors.length > 0 }"
            v-model="formData.zip.value"
            @focus="removeError('zip')"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.zip.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">Country</label>
        <div>
          <country-select
            v-model="formData.country.value"
            :country="formData.country.value"
            topCountry="US"
            className="form-control"
            :usei18n="usei18n"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.country.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group stripe">
        <stripe ref="cardElement" v-model:isFilled="isCardNumberFilledComp" />
      </div>
      <div
        class="alert alert-danger alert-dismissible fade"
        :class="apiStatus"
        role="alert"
      >
        <strong>Error:</strong>
        {{
          errorMessage
            ? errorMessage
            : `There was an error on our side. Please try again later.`
        }}
      </div>
      <div class="btn-container">
        <div
          class="spinner-border action m-auto"
          role="status"
          v-if="isSubmitting"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
        <button
          v-else
          type="submit"
          :disabled="!canSumbit"
          class="btn btn-action btn-fatty"
        >
          Pay
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Stripe from "./StripeElement.vue";
import axios from "axios";
export default {
  components: { Stripe },
  name: "OrganizationForm",
  data() {
    return {
      apiStatus: "d-none",
      userToken: undefined,
      formSubmited: false,
      isSubmitting: false,
      usei18n: false,
      errorMessage: "",
      url: "",
      formData: {
        name: { errors: [], value: null },
        email: { errors: [], value: null },
        line1: { errors: [], value: null },
        city: { errors: [], value: null },
        state: { errors: [], value: null },
        zip: { errors: [], value: null },
        country: { errors: [], value: "US" },
        // cardNumber: { errors: [], value: null },
        // cvv: { errors: [], value: null },
      },
      isCardNumberFilled: false,
      selectedPriceId: "rlp-starter-yearly",
      prices: [
        { id: "rlp-starter-yearly", label: "$1,188.00 yearly" },
        { id: "rlp-starter-monthly", label: "$99.00 monthly" },
      ],
    };
  },
  computed: {
    isCardNumberFilledComp: {
      get: function () {
        return this.isCardNumberFilled;
      },
      set: function (value) {
        if (this.errorMessage) {
          this.errorMessage = "";
          this.apiStatus = "d-none";
        }
        this.isCardNumberFilled = value;
      },
    },
    canSumbit: function () {
      // Check if any fields are empty
      if (this.isCardNumberFilled) {
        for (let inputObject in this.formData) {
          if (
            this.formData[inputObject].value === null ||
            this.formData[inputObject].value == ""
          ) {
            return false;
          }
        }
        return true;
      }
      return false;
    },
  },
  created() {
    if (!this.$route.query.token) {
      this.$router.push({
        name: "Starter",
      });
    }
    document.title = `Sign up for the Rockstar Learning Platform - ${this.$route.name}`;
  },
  mounted() {
    this.userToken = this.$route.query.token;
    axios.get(`/api/users/login?token=${this.userToken}`).then((response) => {
      if (response.data.url) {
        location.replace(`https://${response.data.url}`);
      }
    });
    //TODO: Should we check if the user has already been pushed to RLP?
    window._hsq.push(["setPath", "/rlp-sign-up-billing"]);
    window._hsq.push(["trackPageView"]);
  },
  methods: {
    createSubscription(subscriptionData) {
      //For discussion: Should we create a service for our REST API?
      axios
        .post("/api/create-subscription", subscriptionData)
        .then((response) => {
          // console.log("response", response.data);
          this.url = response.data.rlpResponse.result.url;
          this.formSubmited = true;
          this.isSubmitting = false;
        })

        .catch((err) => {
          if (err.response.data.error && err.response.data.error.message) {
            let message = err.response.data.error.message.includes("API")
              ? "Oops! Something went wrong, please try again later."
              : err.response.data.error.message;
            this.errorMessage = message;
          }

          this.apiStatus = "show";
          this.isSubmitting = false;
        });
    },
    submitBillingForm() {
      if (!this.isSubmitting) {
        this.isSubmitting = true;
        let userData = {};
        Object.keys(this.formData).forEach(
          (key) => (userData[key] = this.formData[key].value)
        );
        let hs_props = userData;
        (hs_props.priceId = this.selectedPriceId),
          window._hsq.push([
            "trackCustomBehavioralEvent",
            {
              name: "pe19900094_rlp_billing_submission",
              properties: hs_props,
            },
          ]);
        this.$refs.cardElement.loadCard(userData).then((response) => {
          if (response.error) {
            // console.log("Something wrong is not right!", response);
            this.isSubmitting = false;
            let message = response.error.message.includes("API")
              ? "Oops! Something went wrong, please try again later."
              : response.error.message;
            this.apiStatus = "show";
            this.errorMessage = message;
            //TODO: handler error in here
          } else {
            this.createSubscription({
              paymentMethodId: response.paymentMethod.id,
              token: this.userToken,
              priceId: this.selectedPriceId,
            });
          }
          // console.log("response", response);
        });
      }
    },

    //remove the empty error on focus
    removeError(inputObject) {
      this.formData[inputObject].errors = this.formData[
        inputObject
      ].errors.filter(function (obj) {
        return obj.type !== "empty";
      });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      //allows dashes and dots too.
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.btn-fatty {
  padding: 7px 30px;
}
.stripe {
  padding-bottom: 19px;
}
section {
  padding-top: 20px;
}
</style>
